import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '../tools.module';
import { BreadcrumbModule } from '../../breadcrumb/breadcrumb.module';
import { BottomNavbarComponent, NavbarButtonComponent, NavbarButtonsComponent, TopNavbarComponent, ChangeSessionModalComponent } from './components';
import { GoToMenuComponent } from './components/go-to-menu/go-to-menu.component';
import { SettingsMenuComponent } from './components/settings-menu/settings-menu.component';
import { AccountManagementMenuComponent } from './components/account-management-menu/account-management-menu.component';
@NgModule({
  declarations: [NavbarButtonComponent, NavbarButtonsComponent, TopNavbarComponent, BottomNavbarComponent, SettingsMenuComponent, GoToMenuComponent, ChangeSessionModalComponent, AccountManagementMenuComponent],
  imports: [CommonModule, RouterModule, ToolsModule, BreadcrumbModule, MaterialModule],
  exports: [NavbarButtonComponent, NavbarButtonsComponent, TopNavbarComponent, BottomNavbarComponent, SettingsMenuComponent, ChangeSessionModalComponent, AccountManagementMenuComponent],
})
export class NavbarModule {}
